import { composer } from '../../component-decorators/composer';
import type { TFunction } from 'i18next';

export const ViewAllApps = composer()
  .withTranslation()
  .compose(({ count, t }: { count: number; t?: TFunction }) =>
    t?.('sub-category-section.view-all-apps', { count }),
  );
